
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import { getTrans as t } from "../../Localization/translations";
import Helper from "../../Helper";



function ApprovalIndex() {

    const tableRef = React.createRef();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        loadApprovals();
    }, []);

    const loadApprovals = async () => {
        try {

            setIsLoading(true);

            const res = await axios.get(API + "approvals/tasks/", {
                headers: authHeader(),
            });

            let rowData = res.data || [];
            if (!Array.isArray(rowData)) rowData = [];

            setData(rowData);
            setIsLoading(false);

        } catch (error) {

            console.error("Error loading approvals:", error);
            setIsLoading(false);

        }
    };

    const approveTask = async (id) => {

        try {

            await axios.post(API + `approvals/approve/${id}/`, {}, {
                headers: authHeader(),
            });

            toast.success("Task approved successfully", {
                position: "top-right",
                autoClose: 1000,
                theme: "light",
            });

            loadApprovals();

        } catch (error) {

            console.error("Approval error:", error);
            toast.error("Failed to approve task");

        }

    };

    const rejectTask = async (id) => {

        try {

            await axios.post(API + `approvals/reject/${id}/`, {}, {
                headers: authHeader(),
            });

            toast.success("Task rejected successfully", {
                position: "top-right",
                autoClose: 1000,
                theme: "light",
            });

            loadApprovals();

        } catch (error) {

            console.error("Reject error:", error);
            toast.error("Failed to reject task");

        }

    };


    return (
        <div className="page-wrapper">

            <ToastContainer />

            <div className="content container-fluid">

                <div className="row">

                    <div className="col-md-12">

                        <MaterialTable
                            tableRef={tableRef}
                            isLoading={isLoading}
                            style={{
                                backgroundColor: "var(--bs-table-bg)",
                                borderBottomWidth: "1px",
                                boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            }}
                            title={<h5 className="mb-0">{t("Approvals")}</h5>}

                            columns={[

                                {
                                    title: "Approval Number",
                                    field: "request_id",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <Link
                                            className="hyperlink"
                                            to="/approvals/view"
                                            state={rowData.request_id}

                                        >
                                            {rowData.request_id}
                                        </Link>
                                    ),

                                },
                                {
                                    title: "Transaction Number",
                                    field: "transaction_number",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <>
                                            <div className="d-xl-none">Transaction No</div>
                                            <div
                                                className="hyperlink"
                                                onClick={() => {
                                                    if (rowData.transaction_type === "manual") {
                                                        navigate("/viewmanualaccounting", { state: rowData.transaction_id });
                                                    } else {
                                                        navigate("/expenses/view", { state: rowData.transaction_id });
                                                    }
                                                }}
                                            >
                                                {rowData.transaction_number}
                                            </div>
                                        </>
                                    ),
                                },
                                {
                                    title: t("Requested Date"),
                                    field: "created_at",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <div>
                                            {Helper.DateNormal
                                                ? Helper.DateNormal(rowData.created_at)
                                                : rowData.created_at}
                                        </div>
                                    ),
                                },
                                {
                                    title: "Workflow",
                                    field: "workflow",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },

                                {
                                    title: "Requested By",
                                    field: "requested_by",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },
                                {
                                    title: "Assigned To",
                                    field: "assigned_to",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },

                                {
                                    title: "Status",
                                    field: "status",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },



                            ]}
                            data={data || []}
                            // actions={[
                            //     {
                            //         icon: () => (
                            //             <button className="btn btn-success btn-sm">
                            //                 Approve
                            //             </button>
                            //         ),
                            //         tooltip: "Approve",
                            //         onClick: (event, rowData) => approveTask(rowData.id),
                            //     },
                            //     {
                            //         icon: () => (
                            //             <button className="btn btn-danger btn-sm">
                            //                 Reject
                            //             </button>
                            //         ),
                            //         tooltip: "Reject",
                            //         onClick: (event, rowData) => rejectTask(rowData.id),
                            //     },
                            // ]}
                            // components={{
                            //     Toolbar: (props) => (
                            //         <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                            //             <MTableToolbar {...props} />

                            //             <Link className="navbar-brand m-0" to="/approvals/add" >
                            //                 <button className="add-part btn btn-primary  mb-0" id="add-task" >+&nbsp; {t('New Request')}</button>
                            //             </Link>

                            //         </div>
                            //     ),
                            // }}

                            options={{
                                headerStyle: {
                                    backgroundColor: "white",
                                    color: "#245C7F",
                                    fontSize: 12,
                                },
                                rowStyle: (rowData, index) => ({
                                    backgroundColor: index % 2 ? "#fff" : "inherit",
                                }),
                                search: true,
                                paging: true,
                                pageSize: 10,
                                pageSizeOptions: [10, 20, 25, 50],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                emptyRowsWhenPaging: false,
                                actionsColumnIndex: -1,
                            }}
                        />

                    </div>

                </div>

            </div>

        </div>
    );
}

export default ApprovalIndex;

